export default __webpack_public_path__ + "static/media/Are you there.930cbe1c.mp3";